import { AttributeTextValue, Cart, CartLine, SalesLine, SalesOrder } from '@msdyn365-commerce/retail-proxy';
import { useState, useEffect } from 'react';

export default function useAttributeValue(cartLine: SalesLine | CartLine | Cart | SalesOrder | undefined, attributeName: string) {
    const [attributeValue, setAttributeValue] = useState<string>();

    useEffect(() => {
        if (cartLine && cartLine.AttributeValues) {
            var attribute = cartLine.AttributeValues.find(attr => {
                return attr.Name === attributeName;
            });
            if (attribute) {
                setAttributeValue((attribute as AttributeTextValue).TextValue);
            }
        }
    });

    return attributeValue;
}
